import { Button } from '@repo/ui/components/button';
import { cn } from '@repo/ui/lib/cn';
import { AlertCircle } from 'lucide-react';
import * as React from 'react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

const ErrorState = React.forwardRef<HTMLDivElement, ErrorStateProps>(
  ({ title = 'Algo deu errado', message, onRetry, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center py-12 text-center',
          className,
        )}
      >
        <div className="bg-destructive/10 mb-4 rounded-full p-4">
          <AlertCircle className="text-destructive h-6 w-6" />
        </div>
        <h3 className="text-foreground text-lg font-semibold">{title}</h3>
        {message && (
          <p className="text-muted-foreground mt-2 max-w-sm">{message}</p>
        )}
        {onRetry && (
          <Button variant="outline" onClick={onRetry} className="mt-6">
            Tentar novamente
          </Button>
        )}
      </div>
    );
  },
);
ErrorState.displayName = 'ErrorState';

export { ErrorState };
